import React from "react";

const SettingsIcon = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.49961 6.15789C8.55567 6.15789 9.41138 6.98242 9.41138 8C9.41138 9.01758 8.55567 9.84211 7.49961 9.84211C6.44356 9.84211 5.58786 9.01758 5.58786 8M3.83846 3.82874C2.93304 3.32105 1.77604 3.62168 1.25375 4.5C0.731456 5.37905 1.04116 6.502 1.94657 7.00821C2.73193 7.44958 2.73193 8.55042 1.94657 8.99179C1.04116 9.49874 0.731456 10.6224 1.25375 11.5C1.77604 12.3783 2.93304 12.6789 3.83769 12.1727C4.62381 11.7314 5.60722 12.2825 5.60722 13.1638C5.60722 14.1777 6.45525 15 7.49984 15C8.54443 15 9.39173 14.1777 9.39173 13.1638C9.39173 12.2825 10.3751 11.7314 11.162 12.1727M13.7459 11.5C14.2689 10.6224 13.9585 9.49874 13.0538 8.99179C12.2677 8.55042 12.2669 7.44958 13.0538 7.00821C13.9585 6.502 14.2689 5.37905 13.7459 4.5C13.2228 3.62168 12.0658 3.32105 11.1619 3.82874C10.3751 4.26863 9.39165 3.71821 9.39165 2.83621C9.39165 1.82232 8.54435 1 7.49977 1C6.45518 1 5.60709 1.82232 5.60709 2.83621"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { SettingsIcon };
